import React from 'react'
import Modal from 'components/Modal'
import { observer } from 'mobx-react'
import { Dialog } from 'components/Dialog'
import './styles.sass'

import QuovoProviderView from './QuovoProvider/ProviderView'
import QuovoProviderState from './QuovoProvider/ProviderState'

const LinkAccountDialog = ({ dialog }) => (
  <Modal isOpened={dialog.showing} onRequestClose={() => dialog.close()}>
    <Dialog className="link-account-dialog">
      {dialog.provider === null &&
        <AccountTypeStep dialog={dialog} />
      }
      {dialog.provider instanceof QuovoProviderState &&
        <QuovoProviderView provider={dialog.provider} />
      }
    </Dialog>
  </Modal>
)

export default observer(LinkAccountDialog)

// Not used anymore, was from when we were using both
// Plaid and Quovo.
const AccountTypeStep = ({ dialog }) => (
  <div className="account-type-step">
    <h1 className="title has-text-centered">
      What type of account are you linking?
    </h1>

    <div className="account-types">
      <AccountType
        name="Bank Account"
        description="By linking your bank account, you can pay via Direct Deposit which means no credit card fees. Woo!"
        onClick={() => dialog.selectType('bank')}
      />
      <AccountType
        name="Investment and/or 401K"
        description="Give your CPA access to quality tax records so you don’t have to spend time scanning tons of documents."
        onClick={() => dialog.selectType('investment-401k')}
      />
    </div>
  </div>
)

const AccountType = ({ name, description, onClick }) => (
  <button className="account-type" onClick={onClick}>
    <div className="name">{name}</div>
    <div className="description">{description}</div>
  </button>
)



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/index.jsx